import React, { useContext } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { ConfigContext } from "../context/GlobalContext";
import { Languages } from "../Utils/Languages";
import CustomerLedgerListLayer from "../components/CustomerLedgerListLayer";


const CustomerLedgerPage = () => {

    const { state } = useContext(ConfigContext);

    return (
        <>

            {/* MasterLayout */}
            <MasterLayout>

                {/* Breadcrumb */}
               <Breadcrumb title={`Ledger Report - ${state?.SELECTEDCUSTOMER?.customer}`} />

                {/* InvoiceListLayer */}
                <CustomerLedgerListLayer />

            </MasterLayout>

        </>
    );
};

export default CustomerLedgerPage;
